import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';

interface IconProps {
  className?: string;
}

function MostlyCloudyIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-mostly-cloudy"
    >
      <path
        d="M55.4072 30C68.062 30.0001 78.3203 40.2593 78.3203 52.9141C78.3203 53.3757 78.3052 53.8342 78.2783 54.2891H85.7412C95.3588 54.2892 103.155 62.0865 103.155 71.7041C103.155 81.3216 95.3587 89.1181 85.7412 89.1182H34.4141C24.7966 89.118 17.0002 81.3215 17 71.7041C17 62.719 23.8048 55.3227 32.542 54.3887C32.511 53.9011 32.4932 53.4095 32.4932 52.9141C32.4932 40.2592 42.7524 30 55.4072 30Z"
        fill="white"
      >
        <FloatAnimation />
      </path>
    </svg>
  );
}

export default memo(MostlyCloudyIcon);
